export type Environment = 'development' | 'alpha' | 'beta' | 'production';
export type FeatureStatus = 'Active' | 'Inactive' | 'Pending';

export interface FeatureFlag {
  featureID: number | string;
  featureName: string;
  code: string;
  branch: string | null;
  workPackageID: number | null;
  development: boolean;
  alpha: boolean;
  beta: boolean;
  production: boolean;
  status: FeatureStatus;
  createdByID: number;
  createdDate: string;
  updatedByID: number;
  updatedDate: string;
}

// Lightweight shape returned by cmdFeaturesNav — used by routing and nav only
export interface NavFlag {
  code: string;
  development: boolean;
  alpha: boolean;
  beta: boolean;
  production: boolean;
}

export interface FeatureFlagTogglePayload {
  featureID: number;
  environment: Environment;
  enabled: boolean;
}

export interface FeatureFlagUpdatePayload {
  featureID: number;
  featureName: string;
  code: string;
  branch: string | null;
  workPackageID: number | null;
  status: FeatureStatus;
}

export interface FeatureFlagCreatePayload {
  featureName: string;
  code: string;
  branch: string | null;
  workPackageID: number | null;
  status: FeatureStatus;
}

// Maps Environment union to the boolean column key on FeatureFlag / NavFlag
export const ENV_KEY_MAP: Record<Environment, keyof Pick<NavFlag, 'development' | 'alpha' | 'beta' | 'production'>> = {
  development: 'development',
  alpha: 'alpha',
  beta: 'beta',
  production: 'production',
};